/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Student_Verify_SuccessInputs */

const en_student_verify_success = /** @type {(inputs: Student_Verify_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verified! You can now subscribe to the Student plan.`)
};

const de_student_verify_success = /** @type {(inputs: Student_Verify_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifiziert! Du kannst jetzt den Studenten-Plan abonnieren.`)
};

const fr_student_verify_success = /** @type {(inputs: Student_Verify_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifie ! Tu peux maintenant t'abonner au plan Etudiant.`)
};

const es_student_verify_success = /** @type {(inputs: Student_Verify_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificado! Ya puedes suscribirte al plan Estudiante.`)
};

const it_student_verify_success = /** @type {(inputs: Student_Verify_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificato! Ora puoi abbonarti al piano Studente.`)
};

const nl_student_verify_success = /** @type {(inputs: Student_Verify_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geverifieerd! Je kunt je nu abonneren op het Studentenplan.`)
};

const pl_student_verify_success = /** @type {(inputs: Student_Verify_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zweryfikowano! Mozesz teraz subskrybowac plan Studencki.`)
};

const fi_student_verify_success = /** @type {(inputs: Student_Verify_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vahvistettu! Voit nyt tilata Opiskelijasuunnitelman.`)
};

const da_student_verify_success = /** @type {(inputs: Student_Verify_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekræftet! Du kan nu abonnere på Studerendeplanen.`)
};

const sv_student_verify_success = /** @type {(inputs: Student_Verify_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifierad! Du kan nu prenumerera på Studentplanen.`)
};

/**
* | output |
* | --- |
* | "Verified! You can now subscribe to the Student plan." |
*
* @param {Student_Verify_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const student_verify_success = /** @type {((inputs?: Student_Verify_SuccessInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Student_Verify_SuccessInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_student_verify_success(inputs)
	if (locale === "fr") return fr_student_verify_success(inputs)
	if (locale === "es") return es_student_verify_success(inputs)
	if (locale === "it") return it_student_verify_success(inputs)
	if (locale === "nl") return nl_student_verify_success(inputs)
	if (locale === "pl") return pl_student_verify_success(inputs)
	if (locale === "fi") return fi_student_verify_success(inputs)
	if (locale === "da") return da_student_verify_success(inputs)
	if (locale === "sv") return sv_student_verify_success(inputs)
	return en_student_verify_success(inputs)
});